import { axiosClient } from '@services/clients'

export async function getExitPages(body) {
  const { data } = await axiosClient.post('/analytics/report', body)

  return data
}
